// extracted by mini-css-extract-plugin
export var checkbox = "Checkbox_checkbox__CGsG6";
export var customCheckbox = "Checkbox_customCheckbox__F+KQy";
export var label = "Checkbox_label__InenQ";